import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Service/Calculator/index.tsx");
